import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { invalidateTradeAndPoolCaches } from './invalidate-trade-caches';

export const useAssignCashPool = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, cashPool }: { id: number; cashPool: number }) =>
      tradesService.assignCashPool(id, cashPool),
    onSuccess: () => invalidateTradeAndPoolCaches(queryClient),
  });
};
